import { Fragment, useState } from 'react';
import { type Editor } from '@tiptap/react';
import { ArrowLeftIcon } from '@/icons';
import { HighlighterIcon } from '@/icons/components/Highlighter';
import { Button } from '@/ui_v3';
import { QUESTION_TEXT_MAX_LENGTH } from '@/views/build/form/schema/quiz/QuizBaseSchema';
import { EditTools } from '../EditTools';
import { TextEditor } from '../TextEditor';
export const QuestionEditTools = ({
  editor,
  additionalTools
}: {
  editor: Editor | null;
  additionalTools?: React.ReactNode[];
}) => {
  const [shouldShowPalette, setShouldShowPalette] = useState(false);
  if (shouldShowPalette) {
    return <div className="flex flex-row items-center gap-4xs">
        <Button variant="transparent" intent="neutral" size="2xs" onClick={() => setShouldShowPalette(false)}>
          <ArrowLeftIcon size="xs" />
          <HighlighterIcon size="xs" />
        </Button>
        <TextEditor.HighlightPalette editor={editor} onSelect={() => {}} onRemove={() => setShouldShowPalette(false)} />
      </div>;
  }
  return <Fragment>
      <TextEditor.UnderlineButton editor={editor} data-sentry-element="unknown" data-sentry-source-file="QuestionEditTools.tsx" />
      <TextEditor.BlockquoteButton editor={editor} data-sentry-element="unknown" data-sentry-source-file="QuestionEditTools.tsx" />
      <TextEditor.HighlightButton editor={editor} onClick={() => setShouldShowPalette(true)} data-sentry-element="unknown" data-sentry-source-file="QuestionEditTools.tsx" />
      <EditTools.Divider data-sentry-element="unknown" data-sentry-source-file="QuestionEditTools.tsx" />
      <TextEditor.EquationButton editor={editor} className="hidden mobile-lg:flex" characterLimit={QUESTION_TEXT_MAX_LENGTH} data-sentry-element="unknown" data-sentry-source-file="QuestionEditTools.tsx" />
      <EditTools.Divider className="hidden mobile-lg:flex" data-sentry-element="unknown" data-sentry-source-file="QuestionEditTools.tsx" />
      {additionalTools?.map((tool, index) => <Fragment key={index}>{tool}</Fragment>)}
    </Fragment>;
};